export default function ImageLightbox({ src, onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center px-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute top-4 left-4 text-white text-3xl leading-none w-10 h-10 flex items-center justify-center"
        aria-label="Close"
      >
        ×
      </button>
      <img
        src={src}
        alt="product preview"
        className="w-full max-w-80 object-contain"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}